import * as yup from "yup";
import {SUBJECT_REQUIRED_ERROR, MESSAGE_REQUIRED_ERROR} from "../../constants/job-creation-constants"
import {EMAIL, EMAIL_TEXT, SUBJECT} from "./email";

export const validationSchema = yup.object().shape({
    email: EMAIL,
    subject: SUBJECT,
    message: EMAIL_TEXT
        .required(MESSAGE_REQUIRED_ERROR),
});